// Import the necessary components
import VerofreshRecord from './VerofreshRecord'

class RouteViolationTypeRecord extends VerofreshRecord {
  static get endpoint () { return 'route-violation/types' }
}

export default RouteViolationTypeRecord
